import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.TarifaPPDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Tarifa", cell: x => ({ data: x.NombreTarifa}) },
    { title: "Peso ref.", cell: x => ({ data: x.Peso }) },
    { title: "Largo ref.", cell: x => ({ data: x.Largo }) },
    { title: "Alto ref.", cell: x => ({ data: x.Alto }) },
    { title: "Ancho ref.", cell: x => ({ data: x.Ancho }) },
    { title: "EAD", cell: x => ({ data: x.ServiciosAdicionales.EntregaDomicilio }) },
    { title: "RAD", cell: x => ({ data: x.ServiciosAdicionales.RecoleccionDomicilio }) },
    { title: "ACU", cell: x => ({ data: nullsafe(x.ServiciosAdicionales.Acuse, x => models.TipoAcuse[x]) }) },
];

/**Obtiene las columnas del grid */
export function columnas(deps: kea.BotonesListaDeps<Entity>): Column[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/tarifapp/list/columns.tsx